async function fetchCookies(url = "/cookies") {
  const response = await fetch(url)
  const json = await response.json()
  return [json, response]
}

export { fetchCookies }
